module.exports = __webpack_public_path__ + "img/hw-s8.382bb0d5.svg";